import React, { useState, useEffect } from 'react';
import { initializeApp } from 'firebase/app';
import { getFirestore, collection, getDocs, query, orderBy, limit } from 'firebase/firestore';
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import SidePanel from './SidePanel';
import AnimatedHamburger from './AnimatedHamburger';
import AdminDashboard from './AdminDashboard';
import ProductCard from './ProductCard';
import ProductModal from './ProductModal';
import WorkerDashboard from './WorkerDashboard';
import logo from '../assets/wycoughlogo.png';
import { getStorage } from 'firebase/storage';
import AnnouncementModal from './AnnouncementModal';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { onSnapshot } from 'firebase/firestore';


// Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyBBOH-NlYaYDu8qpx3WvTZjZEOVLRSXy_s",
    authDomain: "productdatabase-69123.firebaseapp.com",
    projectId: "productdatabase-69123",
    storageBucket: "productdatabase-69123.appspot.com",
    messagingSenderId: "783262629062",
    appId: "1:783262629062:web:d9fb19cce135edafe3ebc7",
    measurementId: "G-83V26XYK26"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);
export const auth = getAuth(app);
export { db, storage };
const messaging = getMessaging(app);



const GoogleFormPage = () => {
  return (
    <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-md p-4">
      <h2 className="text-xl sm:text-2xl font-semibold mb-4">
        Sign Up
      </h2>

      <iframe
        title="Sign Up Form"
        src="https://docs.google.com/forms/d/e/1FAIpQLSdvxTjkbs9Gz433tYkyds1CN1ijLemccSiIwpyQObRQtDtgFg/viewform?embedded=true"
        width="100%"
        height="900"
        frameBorder="0"
        marginHeight="0"
        marginWidth="0"
      >
        Loading…
      </iframe>
    </div>
  );
};



const CannabisRetailerApp = () => {
    const [categories, setCategories] = useState([]);
    const [isSidePanelOpen, setIsSidePanelOpen] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState('All');
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [loading, setLoading] = useState(true);
    const [user, setUser] = useState(null);
    const [isAgeVerified, setIsAgeVerified] = useState(true);
    const [authChecked, setAuthChecked] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);
    const [currentView, setCurrentView] = useState('products');
    const [isWorker, setIsWorker] = useState(false);
    const [products, setProducts] = useState([]);
    const [announcement, setAnnouncement] = useState(null);
    const [showAnnouncement, setShowAnnouncement] = useState(false);

    // Fetch products function - independent of authentication
    const fetchProducts = async () => {
        try {
            console.log("Fetching products...");
            
            const productsCollection = collection(db, 'Products');
            const productSnapshot = await getDocs(productsCollection);
const productList = productSnapshot.docs
  .map(doc => ({
    id: doc.id,
    ...doc.data()
  }))
  .filter(product => !product.hidden)
            
            console.log("Fetched products:", productList);
            
            if (productList && productList.length > 0) {
                setProducts(productList);
                
                // Organize products into categories
                const formattedData = formatFirestoreData(productList);
                setCategories(formattedData);
            } else {
                console.log("No products found in database");
                setProducts([]);
                setCategories([]);
            }
        } catch (error) {
            console.error("Error fetching products:", error);
            setProducts([]);
            setCategories([]);
        }
    };

    const fetchLatestAnnouncement = async () => {
  try {
    const q = query(
      collection(db, 'Announcements'),
      orderBy('createdAt', 'desc'),
      limit(1)
    );
    const snapshot = await getDocs(q);
    if (!snapshot.empty) {
      const data = snapshot.docs[0].data();
      setAnnouncement(data);

      const delaySeconds = data.delaySeconds ?? 10; // <-- customizable delay
      setTimeout(
  () => setShowAnnouncement(true), 
  (data.delaySeconds || 10) * 1000
);
    }
  } catch (error) {
    console.error('Error fetching announcement:', error);
  }
};

    // Format data for categories
    const formatFirestoreData = (products) => {
    const categoryMap = new Map();
    
    // Add "All" category
    categoryMap.set('All', { name: 'All', items: [] });
    
    // Process each product
    products.forEach(product => {
        if (!product) return;
        
        // Add to All category first
        categoryMap.get('All').items.push(product);
        
        // Add to specific category if it exists
        if (product.category) {
            const trimmedCategory = product.category.trim();
            if (!categoryMap.has(trimmedCategory)) {
                categoryMap.set(trimmedCategory, { 
                    name: trimmedCategory, 
                    items: [] 
                });
            }
            categoryMap.get(trimmedCategory).items.push(product);
        }
    });
    
    // Sort items in each category by price (low to high)
    categoryMap.forEach(category => {
        category.items.sort((a, b) => {
            const priceA = typeof a?.price === 'number' ? a.price : parseFloat(a?.price || 0);
            const priceB = typeof b?.price === 'number' ? b.price : parseFloat(b?.price || 0);
            return priceA - priceB;
        });
    });
    
    // Sort categories alphabetically but ensure "Deals" is at the top
    const sortedCategories = Array.from(categoryMap.values()).sort((a, b) => {
        // Ensure "Deals" appears at the top
        if (a.name === 'Deals') return -1;
        if (b.name === 'Deals') return 1;
        if (a.name === 'All') return -1;
        if (b.name === 'All') return 1;
        
        // Sort other categories alphabetically
        return a.name.localeCompare(b.name);
    });
    
    return sortedCategories;
};

    // Initial load - fetch products immediately when component mounts
    useEffect(() => {
        fetchProducts();
        fetchLatestAnnouncement();
    }, []);

    // Auth state monitoring
    useEffect(() => {
        setLoading(true);
        
        const unsubscribe = onAuthStateChanged(auth, async (user) => {
            if (user) {
                setUser(user);
                const idTokenResult = await user.getIdTokenResult();
                const adminStatus = !!idTokenResult.claims.admin;
                const workerStatus = !!idTokenResult.claims.worker;
                setIsAdmin(adminStatus);
                setIsWorker(workerStatus);
            } else {
                setUser(null);
                setIsAdmin(false);
                setIsWorker(false);
            }
            
            setAuthChecked(true);
            setLoading(false);
        });
        
        return () => unsubscribe();
    }, []);


    useEffect(() => {
  const requestNotificationPermission = async () => {
    try {
      const permission = await Notification.requestPermission();
      if (permission === 'granted') {
        const token = await getToken(messaging, {
          vapidKey: 'BHHIwMlwH7ITugByYHmGPT901mEynB2SSPvUUcn0eoxtRXTy3z5vQ6Z9QmlLukt-6bwJZUSSM0VSWvN-45UxBd4'
        });
        console.log('✅ FCM token:', token);

        // Optional: Store the token in Firestore under user's UID or general list
        // await setDoc(doc(db, 'FCMTokens', token), { token }); 
      } else {
        console.warn('🚫 Notification permission denied');
      }
    } catch (err) {
      console.error('🔴 Error getting FCM token:', err);
    }
  };

  requestNotificationPermission();
  

  // Handle foreground notifications
  onMessage(messaging, (payload) => {
    console.log('🔔 Foreground push received:', payload);
    alert(payload.notification?.title || 'New Notification');
  });
}, []);

useEffect(() => {
  const unsubscribe = onSnapshot(collection(db, 'Products'), (snapshot) => {
    snapshot.docChanges().forEach(change => {
      if (change.type === 'added') {
        const newProduct = change.doc.data();
        if (Notification.permission === 'granted') {
          new Notification('🛍️ New Product Added', {
            body: `${newProduct.name || 'A new item'} is now available.`,
            icon: '/logo192.png' // Ensure this file exists in public/
          });
        } else {
          console.log('🔕 Notification skipped, permission not granted.');
        }
      }
    });
  });

  return () => unsubscribe(); // Clean up listener on component unmount
}, []);

    const toggleSidePanel = () => {
        setIsSidePanelOpen(!isSidePanelOpen);
    };

    const handleSelectCategory = (categoryName) => {
        console.log("Selected category:", categoryName);
        setSelectedCategory(categoryName);
        setCurrentView('products');
        setIsSidePanelOpen(false);
    };

    const handleReadMore = (item) => {
        setSelectedProduct(item);
    };

    const handleLogout = async () => {
        try {
            await signOut(auth);
        } catch (error) {
            console.error("Error signing out: ", error);
        }
        
        setUser(null);
        setIsSidePanelOpen(false);
    };

    if (loading) {
        return <div className="flex justify-center items-center h-screen">Loading...</div>;
    }
    
    if (!authChecked) {
        return <div className="flex justify-center items-center h-screen">Checking authentication...</div>;
    }
    
    if (isAdmin) {
        return <AdminDashboard onLogout={handleLogout} isAdmin={true} />;
    }

    if (isWorker) {
        return <WorkerDashboard 
            onLogout={handleLogout} 
            isWorker={true}
            user={user}
        />;
    }

    const handleOpenProducts = () => {
        setCurrentView('products');
        setIsSidePanelOpen(false);
    };
    
    // Get all category names for the sidebar
    const categoryNames = categories.map(category => category.name);
    
    // Find current category to display
    let currentCategory = { name: "All Products", items: [] };
    
    // First, check if we have any products
    if (products.length > 0) {
        if (selectedCategory === 'All') {
            // Show all products
            currentCategory = { name: "All Products", items: products };
        } else {
            // Find the selected category
            const foundCategory = categories.find(c => c.name === selectedCategory);
            if (foundCategory) {
                currentCategory = foundCategory;
            }
        }
    }
    
    console.log("Current category:", selectedCategory);
    console.log("Items to display:", currentCategory.items.length);

    return (
    <div className="min-h-screen pb-4">
        <div className="fixed -z-10 top-0 -left-4 w-96 h-96 bg-gradient-to-r from-blue-500 to-green-500 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-blob"></div>
        <div className="fixed -z-10 top-1/3 right-4 w-96 h-96 bg-gradient-to-r from-green-500 to-blue-500 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-blob animation-delay-2000"></div>
        <div className="fixed -z-10 bottom-0 left-1/3 w-96 h-96 bg-gradient-to-r from-blue-500 to-green-500 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-blob animation-delay-4000"></div>

        <header className="fixed top-0 left-0 right-0 bg-white z-50" style={{
            boxShadow: '0 2px 4px -1px rgba(37, 99, 235, 0.1), 0 1px 2px -1px rgba(16, 185, 129, 0.1)'
        }}>

          {showAnnouncement && announcement && (
  <AnnouncementModal
    announcement={announcement}
    onClose={() => setShowAnnouncement(false)}
  />
)}
            <div className="container mx-auto px-3 py-1 h-16 sm:h-18 flex justify-between items-center">
                <AnimatedHamburger isOpen={isSidePanelOpen} toggle={toggleSidePanel} />
                
                {/* More compact logo container */}
                <div 
  className="flex items-center justify-center h-12 sm:h-14 w-24 sm:w-32 cursor-pointer"
  onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
>
  <img 
    src={logo} 
    alt="Wycough Members Only Logo" 
    className="max-h-full max-w-full object-contain" 
    style={{ transform: 'scale(3.5)' }}
  />
</div>
                
                <div className="w-8"></div> {/* Spacer to balance the header */}
            </div>
        </header>
        <SidePanel 
            isOpen={isSidePanelOpen}
            onClose={() => setIsSidePanelOpen(false)}
            categories={categoryNames}
            onSelectCategory={handleSelectCategory}
            selectedCategory={selectedCategory}
            onLogout={handleLogout}
            onOpenProducts={handleOpenProducts}
            isAdmin={isAdmin}
            isWorker={isWorker}
            onSwitchToProducts={handleOpenProducts}
            onViewChange={(view) => setCurrentView(view)}
            activeView={currentView}
        />
    
        <main className="container mx-auto px-4 mt-24 sm:mt-28">
            {currentView === 'products' && (
  <div className="mb-8">
  <h2 className="text-xl sm:text-2xl font-semibold mb-4">{currentCategory.name}</h2>

  {selectedCategory === 'All' ? (
    categories
      .filter(c => c.name !== 'All')
      .map((category) => (
        <div key={category.name} className="mb-6">
          <h3 className="text-lg sm:text-xl font-semibold mb-2">{category.name}</h3>

          {category.name === 'Deals' ? (
            <div className="flex flex-col space-y-4 items-center">
              {category.items.map((item) => (
                <div key={item.id || Math.random()} className="flex justify-center w-full max-w-4xl">
                  <ProductCard item={item} onReadMore={handleReadMore} isAdmin={isAdmin} />
                </div>
              ))}
            </div>
          ) : (
            <div className="flex overflow-x-auto space-x-6 pb-2 scrollbar-thin scrollbar-thumb-gray-400">
              {(() => {
                const subcatMap = {};
                category.items.forEach(item => {
                  const sub = item.subcategory?.trim() || 'Uncategorized';
                  if (!subcatMap[sub]) subcatMap[sub] = [];
                  subcatMap[sub].push(item);
                });

                return Object.entries(subcatMap).map(([subcat, items], index) => {
                  const sortedItems = category.name === 'Prerolls'
                    ? [...items].sort((a, b) => {
                        const lenA = a.description?.length || 0;
                        const lenB = b.description?.length || 0;
                        return lenB !== lenA ? lenB - lenA : parseFloat(a.price || 0) - parseFloat(b.price || 0);
                      })
                    : items;

                  return (
                    <div
                      key={subcat}
                      className={`flex flex-col items-start flex-shrink-0 ${index !== 0 ? 'border-l border-gray-300 pl-4' : ''}`}
                    >
                      <p className="text-xs font-semibold text-gray-500 mb-2 whitespace-nowrap">
                        {`${category.name} / ${subcat}`}
                      </p>
                      <div className="flex space-x-4">
                        {sortedItems.map(item => (
                          <div key={item.id || Math.random()} className="flex-shrink-0 w-56 sm:w-64 md:w-72">
                            <ProductCard item={item} onReadMore={handleReadMore} isAdmin={isAdmin} />
                          </div>
                        ))}
                      </div>
                    </div>
                  );
                });
              })()}
            </div>
          )}
        </div>
      ))
  ) : (
    <div className={`${
      selectedCategory === 'Deals'
        ? 'flex flex-col space-y-4 items-center'
        : 'flex overflow-x-auto space-x-6 pb-2 scrollbar-thin scrollbar-thumb-gray-400'
    }`}>
      {(() => {
  if (selectedCategory === 'Deals') {
    // Render all deals stacked vertically
    return currentCategory.items.map(item => (
      <div key={item.id || Math.random()} className="flex justify-center w-full max-w-4xl">
        <ProductCard item={item} onReadMore={handleReadMore} isAdmin={isAdmin} />
      </div>
    ));
  }

  // Default behavior for all other categories
  const subcatMap = {};
  currentCategory.items.forEach(item => {
    const sub = item.subcategory?.trim() || 'Uncategorized';
    if (!subcatMap[sub]) subcatMap[sub] = [];
    subcatMap[sub].push(item);
  });

  return Object.entries(subcatMap).map(([subcat, items], index) => {
    const sortedItems = selectedCategory === 'Prerolls'
      ? [...items].sort((a, b) => {
          const lenA = a.description?.length || 0;
          const lenB = b.description?.length || 0;
          return lenB !== lenA ? lenB - lenA : parseFloat(a.price || 0) - parseFloat(b.price || 0);
        })
      : items;

    return (
      <div
        key={subcat}
        className={`flex flex-col items-start flex-shrink-0 ${index !== 0 ? 'border-l border-gray-300 pl-4' : ''}`}
      >
        <p className="text-xs font-semibold text-gray-500 mb-2 whitespace-nowrap">
          {`${currentCategory.name} / ${subcat}`}
        </p>
        <div className="flex space-x-4">
          {sortedItems.map(item => (
            <div key={item.id || Math.random()} className="flex-shrink-0 w-56 sm:w-64 md:w-72">
              <ProductCard item={item} onReadMore={handleReadMore} isAdmin={isAdmin} />
            </div>
          ))}
        </div>
      </div>
    );
  });
})()}


    </div>
  )}
</div>
            )}


            {currentView === 'signup' && <GoogleFormPage />}
        </main>

        {selectedProduct && (
            <ProductModal 
                item={selectedProduct} 
                isOpen={!!selectedProduct} 
                onClose={() => setSelectedProduct(null)}
            />
        )}
    </div>
);
};

export default CannabisRetailerApp;